import axios from 'axios';
import {
  GET_PERSONAL_INFORMATIONS_REQUEST,
  GET_PERSONAL_INFORMATIONS_SUCCESS,
  GET_PERSONAL_INFORMATIONS_FAILURE,

  UPDATE_PERSONAL_INFORMATIONS_PHONE_REQUEST,
  UPDATE_PERSONAL_INFORMATIONS_PHONE_SUCCESS,
  UPDATE_PERSONAL_INFORMATIONS_PHONE_FAILURE,

  UPDATE_PERSONAL_INFORMATIONS_EMAIL_REQUEST,
  UPDATE_PERSONAL_INFORMATIONS_EMAIL_SUCCESS,
  UPDATE_PERSONAL_INFORMATIONS_EMAIL_FAILURE,

  UPDATE_PERSONAL_INFORMATIONS_CITY_REQUEST,
  UPDATE_PERSONAL_INFORMATIONS_CITY_SUCCESS,
  UPDATE_PERSONAL_INFORMATIONS_CITY_FAILURE,

  UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_REQUEST,
  UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_SUCCESS,
  UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_FAILURE,
  
} from 'Store/constants';

import errorMessage from './errorMessage';
import { openModal } from './modalActions';

export const getPersonalInformations = () => async dispatch => {
  try {
    dispatch({
      type: GET_PERSONAL_INFORMATIONS_REQUEST
    });

    const res = await axios.get('/users/informations');

    dispatch({
      type: GET_PERSONAL_INFORMATIONS_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_PERSONAL_INFORMATIONS_FAILURE,
      payload: errorMessage
    });
  }
};

export const updatePersonalInformationsTeamCity = formData => {
  return new Promise(async (resolve, reject) => {
    try {

      const res = await axios.put('/users/informations/membership-info', formData);
      resolve(res);

    } catch (e) {
      const error = e.response?.data;
      reject(error || errorMessage);
    }
  });
};

export const saveInformationsOccupation = formData => {
  return new Promise(async (resolve, reject) => {
    try {

      const res = await axios.put('/users/informations/occupation', formData);
      resolve(res);

    } catch (e) {
      const error = e.response?.data;
      reject(error || errorMessage);
    }
  });
};

export const getCountries = () => {
  return new Promise(async (resolve, reject) => {
    try {

      const res = await axios.get('/users/countries');
      resolve(res);

    } catch (e) {
      const error = e.response?.data;
      reject(error || errorMessage);
    }
  });
};

export const getOccupations = () => {
  return new Promise(async (resolve, reject) => {
    try {

      const res = await axios.get('/users/occupations');
      resolve(res);

    } catch (e) {
      const error = e.response?.data;
      reject(error || errorMessage);
    }
  });
};


export const getTeamsAndCity = () => {
  return new Promise(async (resolve, reject) => {
    try {

      const res = await axios.get('/cms/userOptions/teams-cities');
      resolve(res);

    } catch (e) {
      const error = e.response?.data;
      reject(error || errorMessage);
    }
  });
};

export const updatePersonalInformationsPhone = phone => dispatch => {
  return new Promise(async (resolve, reject) => {

    try {
      dispatch({
        type: UPDATE_PERSONAL_INFORMATIONS_PHONE_REQUEST
      });

      const res = await axios.put('/users/informations/phone', phone);

      dispatch({
        type: UPDATE_PERSONAL_INFORMATIONS_PHONE_SUCCESS,
        payload: res.data
      });
      dispatch(openModal('verifyNumberSuccess'));
      resolve();
    } catch (e) {
      dispatch({
        type: UPDATE_PERSONAL_INFORMATIONS_PHONE_FAILURE,
        payload: errorMessage
      });
      reject(e);
    }
  });
};

export const updatePersonalInformationsEmailByOtp = email => dispatch => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({
        type: UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_REQUEST
      });

      const res = await axios.put('/users/informations/by-otp/email', email);

      dispatch({
        type: UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_SUCCESS,
        payload: res.data
      });
      resolve();
    } catch (e) {
      dispatch({
        type: UPDATE_PERSONAL_INFORMATIONS_EMAIL_BY_OTP_FAILURE,
        payload: errorMessage
      });
      reject(e);
    }
  });
};

export const updatePersonalInformationsEmail = (email, verifyEmailRequired = true) => async dispatch => {
  try {
    dispatch({
      type: UPDATE_PERSONAL_INFORMATIONS_EMAIL_REQUEST
    });

    const res = await axios.put('/users/informations/email', {
      email,
      verifyEmailRequired
    });

    dispatch({
      type: UPDATE_PERSONAL_INFORMATIONS_EMAIL_SUCCESS,
      payload: res.data
    });

    return res;

  } catch (e) {
    const error = e.response && e.response.data;

    dispatch({
      type: UPDATE_PERSONAL_INFORMATIONS_EMAIL_FAILURE,
      payload: (error && error.message) || errorMessage
    });
    
    throw e;
  }
};

export const updatePersonalInformationsCity = city => async dispatch => {
  try {
    dispatch({
      type: UPDATE_PERSONAL_INFORMATIONS_CITY_REQUEST
    });

    await axios.put('/users/informations/city', {
      city
    });

    dispatch({
      type: UPDATE_PERSONAL_INFORMATIONS_CITY_SUCCESS,
      payload: city
    });

  } catch (e) {
    const error = e.response && e.response.data;

    dispatch({
      type: UPDATE_PERSONAL_INFORMATIONS_CITY_FAILURE,
      payload: (error && error.message) || errorMessage
    });
  }
};

export const getPersonalInformationsAggrement = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        url: '/cms/userAgreement/latestPersonalInfoAgreement',
        method: 'get'
      });
  
      resolve(res);
    } catch (e) {
      reject(e);
    }
  });
};

